import React from 'react';
import './styles.css';
import Views from "./components/views";

const AutoCrawlOrderJobs = () => {

  return (<Views/>);
};

export default AutoCrawlOrderJobs;